import { useEffect, useState } from "react";
import BossDialog from "../../components/BossDialog";
import * as API from "../../framework/API/api";
import { ENTITYNAME, TOAST_TYPES } from "../../framework/constant/constant";
import { Loader } from "../../framework/forms/helpercomponents/Loader";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { DateOnlyCell } from "../../framework/forms/helpercomponents/CustomGridCells/DateCell";
import { TimeCell } from "../../framework/forms/helpercomponents/CustomGridCells/TimeCell";
import "./RecursivePlanPopup.css";
import ToastNotification from "../../components/ToastNotification";
import { useTranslation } from "../../locale/useTranslation";

const weekPalette = [
    { bg: "#e9f2ff", color: "#225ea8" },
    { bg: "#ecfaef", color: "#287d4d" },
    { bg: "#fff7e4", color: "#8a6406" },
    { bg: "#f2ecff", color: "#5c42a8" },
    { bg: "#ffefee", color: "#9f3b33" },
    { bg: "#ebfbff", color: "#116a82" }
];


const WeekTagCell = (props) => {
    const value = props.dataItem?.[props.field];
    const weekNo = Number(value);
    const palette = Number.isFinite(weekNo)
        ? weekPalette[Math.abs(weekNo) % weekPalette.length]
        : { bg: "#edf2f7", color: "#334155" };

    return (
        <td>
            <span className="recursive-plan-popup__tag recursive-plan-popup__tag--week" style={{ backgroundColor: palette.bg, color: palette.color }}>
                {value ?? "-"}
            </span>
        </td>
    );
};

const RecursivePlanPopup = ({ onClose, RecursionParentProgramSchedule_id }) => {

    const lang = useTranslation();
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        loadData();
    }, [RecursionParentProgramSchedule_id])

    const loadData = async () => {
        try {
            setIsLoading(true);
            let res = await API.getRecursivePlan(RecursionParentProgramSchedule_id);
            if (res.success) {
                setData(res.data);
            } else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            }
        } catch (error) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: error.message });
        } finally {
            setIsLoading(false);
        }
    }

    return <BossDialog
        title={"Recursive Plan"}
        onClose={onClose}
        height="74vh"
        width="min(1040px, 92vw)"
        style={{ borderRadius: "12px" }}
    >
        <div className="recursive-plan-popup">
            <div className="recursive-plan-popup__meta">
                <div className="recursive-plan-popup__badge"></div>
                <div className="recursive-plan-popup__hint">{data.length} Slots Planned in Sequence</div>
            </div>

            {isLoading && <Loader height={"420px"} />}

            {!isLoading && <div className="recursive-plan-popup__grid-wrap">
                <Grid data={data} style={{ height: "100%" }} rowHeight={46} resizable={true} className="recursive-plan-popup__grid">
                    <GridColumn field={'weekNumber'} title={'Week'} cell={WeekTagCell} width={'90px'} />
                    <GridColumn field={'SlotDateTime'} title={'Date'} cell={(props) => <DateOnlyCell {...props} format="DD-MMM-YYYY" />} width={'145px'} />
                    <GridColumn field={'SlotDateTime'} title={'Time'} cell={TimeCell} width={'130px'} />
                    <GridColumn field={'weekDay'} title={'Day'} width={'130px'} />
                    <GridColumn field={'mediaEpisode.Title'} title={'Title'} />
                    <GridColumn field={'mediaEpisode.EpisodeNumber'} title={'Episode No.'} width={'120px'} />
                </Grid>
            </div>}
        </div>
    </BossDialog>
}

export default RecursivePlanPopup